import React from "react";
import { Container, Typography, Box } from "@mui/material";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Pagination, Navigation } from "swiper/modules";

import bg from "../../assets/img/secciones/fondo_Modulos.webp";

import mod1 from "../../assets/png/mod1.png";
import mod2 from "../../assets/png/mod2.png";
import mod3 from "../../assets/png/mod3.png";
import mod4 from "../../assets/png/mod4.png";
import mod5 from "../../assets/png/mod5.png";
import mod6 from "../../assets/png/mod6.png";
import mod7 from "../../assets/png/mod7.png";
import mod8 from "../../assets/png/mod8.png";

const images = [
  { src: mod1, alt: "Imagen 1", url: "https://hydroplay.mx/modulos/m1/index.html" },
  { src: mod2, alt: "Imagen 2", url: "https://hydroplay.mx/modulos/m2/index.html" },
  { src: mod3, alt: "Imagen 3", url: "https://hydroplay.mx/modulos/m3/index.html" },
  { src: mod4, alt: "Imagen 4", url: "https://hydroplay.mx/modulos/m4/index.html" },
  { src: mod5, alt: "Imagen 5", url: "https://hydroplay.mx/modulos/m5/index.html" },
  { src: mod6, alt: "Imagen 6", url: "https://hydroplay.mx/modulos/m7/index.html" },
  { src: mod7, alt: "Imagen 7", url: "https://hydroplay.mx/modulos/m6/index.html" },
  //{ src: mod8, alt: "Imagen 8", url: "https://hydroplay.mx/modulos/m1/index.html" },
];

function Modules() {
  return (
    <Box
      id="modules"
      sx={{
        backgroundImage: `url(${bg})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        color: "white",
        py: 8,
        minHeight: "85vh",
      }}
    >
      <Container maxWidth="lg">
        <Typography
          variant="h2"
          component="h2"
          color="#D10056"
          gutterBottom
          sx={{
            textAlign: "center",
            fontWeight: "bold",
            marginTop: { xs: 4 },
            fontSize: { xs: "1.5rem", sm: "2.5rem", md: "3rem" },
            fontFamily: "Montserrat, sans-serif",
          }}
        >
          Interacción con Módulos
        </Typography>

        <Swiper
          slidesPerView={4}
          spaceBetween={20}
          pagination={{ clickable: true }}
          navigation
          modules={[Pagination, Navigation]}
          breakpoints={{
            320: { slidesPerView: 1 },
            600: { slidesPerView: 2 },
            900: { slidesPerView: 3 },
            1200: { slidesPerView: 4 },
          }}
          style={{ padding: "20px 0" }}
        >
          {images.map((image, index) => (
            <SwiperSlide key={index}>
              <a href={image.url} target="_blank" rel="noopener noreferrer">
                <img
                  src={image.src}
                  alt={image.alt}
                  style={{ width: "100%", borderRadius: "10px" }}
                />
              </a>
            </SwiperSlide>
          ))}
        </Swiper>
      </Container>
    </Box>
  );
}

export default Modules;
